module.exports = __webpack_public_path__ + "static/media/13@960w.f826ee3f.jpg";